import * as actionTypes from '../actions/actionTypes'

const initialState = {
    isDarkMode: false,
}

const uiReducer = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actionTypes.SET_IS_DARK_MODE:
            if (payload.isDarkMode !== undefined)
                return {
                    ...state,
                    isDarkMode: payload.isDarkMode,
                }
            return { ...state }

        default:
            return { ...state }
    }
}

export default uiReducer